import React from 'react';
import { CommentFilesInterface } from '../../../../interfaces/TaskInterface';
import { RenderFilePreview } from '../../../renderFilePreview';
import { RenderImagePreview } from '../../../renderImagePreview';
import RenderVideoFile from '../../../renderVideoFile';
import { FileBox, FileDiv } from './styles';

interface Props {
  imageFiles?: CommentFilesInterface[];
  videoFiles?: CommentFilesInterface[];
  audioFiles?: CommentFilesInterface[];
  otherFiles?: CommentFilesInterface[];
  onClickFile: (file: CommentFilesInterface) => void;
}

const FileAttachments = ({ imageFiles, videoFiles, audioFiles, otherFiles, onClickFile }: Props) => {
  return (
    <>
      {imageFiles &&
        imageFiles.length > 0 &&
        imageFiles.map((file) => <RenderImagePreview key={file?.href} imageUrl={file?.href} altText={file?.name} />)}

      {videoFiles &&
        videoFiles.length > 0 &&
        videoFiles.map((file) => <RenderVideoFile key={file?.href} videoUrl={file?.href} videoName={file?.name} />)}

      {audioFiles &&
        audioFiles.length > 0 &&
        audioFiles.map((file) => (
          <audio key={file?.href} controls>
            <source type='audio/mp3' src={file?.href} />
          </audio>
        ))}

      {otherFiles && otherFiles.length > 0 && (
        <FileBox>
          {otherFiles.map((file) => (
            <FileDiv key={file?.href}>
              <RenderFilePreview file={file} maxWidth={240} onClickUpdate={() => onClickFile(file)} />
            </FileDiv>
          ))}
        </FileBox>
      )}
    </>
  );
};

export default React.memo(FileAttachments);
